import { DEFAULT_PARTY_CATALOG } from './painel-state.js';
import { buildTerritoryOpportunityData } from './painel-data.js';

export function renderTerritoryOpportunities(container, agg, context = {}) {
  if (!container) return;
  const data = agg?.territorios || (context.dados
    ? buildTerritoryOpportunityData(context.dados, {
      cargoKey: context.cargoKey || agg?.cargoKey,
      scope: context.scope || 'municipio',
      zona: context.zona,
      partidosCatalog: context.partidosCatalog || DEFAULT_PARTY_CATALOG,
    })
    : null);

  const redutos = [
    ...((data?.redutos?.candidatos || []).slice(0, 3)),
    ...((data?.redutos?.partidos || []).slice(0, 2)),
  ].slice(0, 5);
  const oportunidades = [
    ...((data?.oportunidades?.candidatos || []).slice(0, 4)),
    ...((data?.oportunidades?.partidos || []).slice(0, 2)),
  ].slice(0, 5);

  if (!data || (!redutos.length && !oportunidades.length)) {
    container.innerHTML = `
      <div class="pn-territory-card is-empty" data-territory-opportunities="${esc(context.scope || 'municipio')}">
        <div class="pn-chart-title"><div class="pn-ct-bar pn-ct-bar--success"></div>REDUTOS E OPORTUNIDADES</div>
        <p>Nenhum reduto dominante ou oportunidade de virada foi identificado neste recorte.</p>
      </div>
    `;
    return;
  }

  container.innerHTML = `
    <div class="pn-territory-card" data-territory-opportunities="${esc(context.scope || data.scope || 'municipio')}">
      <div class="pn-territory-header">
        <div>
          <div class="pn-chart-title"><div class="pn-ct-bar pn-ct-bar--success"></div>REDUTOS E OPORTUNIDADES</div>
          <p>Leitura autom&aacute;tica de se&ccedil;&otilde;es onde candidatos ou partidos t&ecirc;m dom&iacute;nio local, disputa de virada ou sinal territorial relevante.</p>
        </div>
        <span class="pn-territory-count">${formatNum(data.totalSections || 0)} se&ccedil;&otilde;es analisadas</span>
      </div>
      <div class="pn-territory-grid">
        ${renderTerritoryBlock('Redutos dominantes', redutos, 'reduto')}
        ${renderTerritoryBlock('Oportunidades de virada', oportunidades, 'oportunidade')}
      </div>
      ${renderTerritoryTrendNote(data.tendencias)}
    </div>
  `;
}

function renderTerritoryBlock(title, rows, kind) {
  const visible = Array.isArray(rows) ? rows.slice(0, 5) : [];
  if (!visible.length) {
    return `
      <div class="pn-territory-block">
        <div class="pn-territory-subtitle">${esc(title)}</div>
        <div class="pn-empty pn-territory-empty"><p>Nenhum item classificado neste grupo.</p></div>
      </div>
    `;
  }

  return `
    <div class="pn-territory-block">
      <div class="pn-territory-subtitle">${esc(title)}</div>
      <div class="pn-territory-list">
        ${visible.map(row => renderTerritoryRow(row, kind)).join('')}
      </div>
    </div>
  `;
}

function renderTerritoryRow(row, kind) {
  const isParty = row.tipo === 'partido';
  const label = isParty
    ? esc(row.nome)
    : `${esc(row.nome)}${row.numero ? ` &middot; ${esc(row.numero)}` : ''}`;
  const badge = isParty ? 'Partido' : 'Candidato';
  const detail = kind === 'reduto'
    ? `${formatPercentCompact(row.percentual)} dos votos &middot; margem de ${formatNum(row.marginVotes)}`
    : `${formatPercentCompact(row.percentual)} dos votos &middot; ${formatNum(row.votesToLead)} voto(s) para virar`;
  return `
    <div class="pn-territory-row" data-territory-kind="${esc(kind)}">
      <div>
        <span class="pn-territory-badge">${esc(badge)}</span>
        <strong>${label}</strong>
        <small>Zona ${esc(row.zona || '-')} &middot; Se&ccedil;&atilde;o ${esc(row.secao || '-')} &middot; ${detail}</small>
      </div>
      <span class="pn-territory-score">${formatNum(Math.round(Number(row.score || 0)))}</span>
    </div>
  `;
}

function renderTerritoryTrendNote(tendencias = {}) {
  if (tendencias.available) {
    const growth = Array.isArray(tendencias.crescimento) ? tendencias.crescimento[0] : null;
    const decline = Array.isArray(tendencias.queda) ? tendencias.queda[0] : null;
    return `
      <div class="pn-territory-trends">
        ${growth ? `<span><strong>Crescimento:</strong> ${esc(growth.nome)} +${formatPercentCompact(growth.deltaPct)} na Zona ${esc(growth.zona)} &middot; Se&ccedil;&atilde;o ${esc(growth.secao)}.</span>` : ''}
        ${decline ? `<span><strong>Queda:</strong> ${esc(decline.nome)} ${formatPercentCompact(decline.deltaPct)} na Zona ${esc(decline.zona)} &middot; Se&ccedil;&atilde;o ${esc(decline.secao)}.</span>` : ''}
      </div>
    `;
  }
  return `<div class="pn-territory-note">${esc(tendencias.note || 'Tendencia indisponivel sem eleicao anterior comparavel.')}</div>`;
}

function esc(str) {
  if (str == null) return '';
  const el = document.createElement('span');
  el.textContent = String(str);
  return el.innerHTML;
}

function formatNum(n) {
  return (n || 0).toLocaleString('pt-BR');
}

function formatPercentCompact(n) {
  return `${(Number(n) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 2 })}%`;
}
